var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('kbd',[_vm._v(_vm._s(_vm.before))]),_vm._v(" → "),_c('kbd',[_vm._v(_vm._s(_vm.after))])])
}
var staticRenderFns = []

export { render, staticRenderFns }